<template>
  <div class="flex">
    <div
      :class="[
        'w-6 h-6 won-tag-light-gray rounded-l-md border-r border-[#DBDBDC]',
        'cursor-pointer flex items-center justify-center select-none',
      ]"
      @click="builderStyle.lineHeightMinus"
    >
      <MinusIcon/>
    </div>

    <div
      :class="[
        'w-[30px] h-6 flex justify-center items-center cursor-pointer',
        'won-tag-light-gray select-none'
      ]"
      @click="builderStyle.resetLineHeight"
    >
        <TextSizeIcon/>
    </div>

    <div
      :class="[
        'w-6 h-6 won-tag-light-gray rounded-r-md border-l border-[#DBDBDC]',
        'cursor-pointer flex items-center justify-center select-none',
      ]"
      @click="builderStyle.lineHeightPlus"
    >
      <PlusIcon/>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useBuilderStyles } from '../../store/builder-style.store'

import { PlusIcon, MinusIcon} from "@heroicons/vue/24/solid";
import TextSizeIcon from "../../icons/pdf-actions/text-size.vue"

const builderStyle = useBuilderStyles()
const { zoom } = storeToRefs(builderStyle)
</script>
